import { BASE_URL } from "../config/api";

export function getFullPath(pathValue?: string | null): string | null {
  if (!pathValue) return null;

  const trimmedPath = pathValue.trim();
  if (!trimmedPath) return null;

  if (
    trimmedPath.startsWith("http://") ||
    trimmedPath.startsWith("https://") ||
    trimmedPath.startsWith("data:") ||
    trimmedPath.startsWith("blob:")
  ) {
    return trimmedPath;
  }

  // Keep Vite static assets untouched.
  if (trimmedPath.startsWith("/assets/")) {
    return trimmedPath;
  }

  const baseUrl = BASE_URL.replace(/\/api\/?$/, "");
  const normalizedPath = trimmedPath.startsWith("/")
    ? trimmedPath.substring(1)
    : trimmedPath;

  return normalizedPath.startsWith("uploads/")
    ? `${baseUrl}/${normalizedPath}`
    : `${baseUrl}/uploads/${normalizedPath}`;
}
